export default __webpack_public_path__ + "static/media/new_restaurant.72b938c1.svg";